import { Union } from "../utils/union-type";

export default Union("Status", {
  Idle: [],
  Processing: [],
  Saved: [],
  Updated: [],
  Failed: []
});
